import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5945742e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "py-4 px-4 empty-hint"
}
const _hoisted_2 = {
  key: 1,
  class: "history-list"
}
const _hoisted_3 = { class: "status" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "loading"
}
const _hoisted_8 = {
  key: 1,
  class: "button mt-1"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Jetzt Bestellen ")

import { PropType, computed } from 'vue';
import { ISearchResult, EPlateType, MonthShortMap } from '@/classes/interfaces/data';
import LicenseDisplay from './LicenseDisplay.vue';
import LoadingAnimation from '@/assets/animations/animation-loading.json';


export default /*#__PURE__*/_defineComponent({
  props: {
  Code1: { type: String, required: true },
  History: { type: Array as PropType<ISearchResult[]>, required: true },
},
  emits: ["order"],
  setup(__props) {

const Props = __props




const VisibleItems = computed(() => {
  const AllItems = [...Props.History];

  return AllItems.filter((x) => x.Code1 == Props.Code1).splice(0, 8);
});

return (_ctx: any,_cache: any) => {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(VisibleItems).length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Hier tauchen alle überprüften Kennzeichen auf. "))
      : _createCommentVNode("", true),
    (_unref(VisibleItems).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(VisibleItems), (HistoryItem) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${HistoryItem.Code2}-${HistoryItem.Code3}`,
              class: _normalizeClass({ 'not-available': !HistoryItem.Available, loading: HistoryItem.Loading })
            }, [
              _createVNode(LicenseDisplay, {
                License: HistoryItem,
                Small: true
              }, null, 8, ["License"]),
              _createElementVNode("div", _hoisted_3, [
                (HistoryItem.Available)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Verfügbar"))
                  : (HistoryItem.Loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, "Nicht Verfügbar"))
              ]),
              (HistoryItem.Loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_Vue3Lottie, {
                      animationData: _unref(LoadingAnimation),
                      height: 100,
                      width: 100
                    }, null, 8, ["animationData"])
                  ]))
                : _createCommentVNode("", true),
              (HistoryItem.Available)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "call-to-action-button no-animation",
                      onClick: ($event: any) => (_ctx.$emit('order', HistoryItem))
                    }, [
                      _hoisted_10,
                      _createVNode(_component_font_awesome_icon, {
                        style: { color: '#fff' },
                        icon: ['fas', 'cart-shopping']
                      })
                    ], 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})